import React, { Component } from 'react';

import { connect } from "react-redux";
import Home from './Home'
import _ from 'lodash';
import axios from 'axios';
import intl from 'react-intl-universal';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import NavMenu  from './NavMenu';
import Footer from './Footer';


const SUPPOER_LOCALES = [
  {
    name: 'DE',
    value: 'de-DE'
  },
  {
    name: 'EN',
    value: 'en-US'
  }
];

class Layout extends Component {

  constructor(props) {
    super(props)
    this.renderLocaleSelector = this.renderLocaleSelector.bind(this);
  }

  state = {
    initDone: false,
    dataload: false,
    active: "de-DE" 
  }
 
    componentDidMount() {
        this.loadLocales();
      }
  
  static displayName = Layout.name;
  
  
  render () {  
   
    //console.log(this.props)
   
    
    if (this.props.islogin) {
    return (
      this.state.initDone &&  (
      <div >
        <Grid 
          container 
          direction="row"
          justifyContent="space-around"
         className="navmenu"
         >
            <Grid item xs={12} sm={2} md={2}>
            <img className="logo" src="../images/nts.png" alt="NTS"  />
            </Grid>
            <Grid item xs={12} sm={9} md={8} align="right">
              <NavMenu  />
            </Grid>
            <Grid item xs={12} sm={1} md={2} align="right">
              {this.renderLocaleSelector()}
            </Grid>
          </Grid> 
          <Grid > 

          {this.props.children}
          </Grid>
          <Footer />
      </div>
      )
    );
  }

  if (!this.props.islogin) {
    return (
      this.state.initDone &&  (
      <div>
        <Grid 
         container 
         direction="row"
         justifyContent="space-around" 
         className="navmenu"
         >
        <Grid item xs={2}>
        <img className="logo" src="../images/nts.png" alt="NTS"  />
          </Grid>
          <Grid item xs={9} align="right">
            
          </Grid>
          <Grid item xs={1} align="right">
            {this.renderLocaleSelector()}
          </Grid>
          </Grid> 
          <Grid >  
            <Home />
          </Grid>
      </div>
      )
    );
  }

  }

  loadLocales(dochangelang) {
    let changelang = dochangelang;
    let currentLocale = intl.determineLocale({
      urlLocaleKey: 'lang',
      cookieLocaleKey: 'lang'
    });

    if (changelang !== undefined) {
      this.setState({ 
        initDone: false,
        dataload: false
      });
      currentLocale = changelang;
     }

    
    if (!_.find(SUPPOER_LOCALES, { value: currentLocale })) {
      currentLocale = 'de-DE';
    }

    axios
      .get(`locales/${currentLocale}.json`)
      .then(res => {
        return intl.init({
          currentLocale,
          locales: {
            [currentLocale]: res.data
          }
        });
      })
      .then(() => {
        // After loading CLDR locale data, start to render
        this.setState({ 
          initDone: true,
          dataload: true
        });
      });
  }

  renderLocaleSelector() {
    //let langtrans = "";
    
    if (intl.options.currentLocale === "de-DE"){
      //langtrans="DE";
    }
    if (intl.options.currentLocale === "en-US") {
      // langtrans = "EN";
    }
    return ( 
     
      <FormControl fullWidth>
      <InputLabel id="sprache-select-label">{intl.options.currentLocale}</InputLabel>
      <Select
        labelId="sprache-select-label"
        id="sprache-select"
        label="Sprache"    
      >
        {SUPPOER_LOCALES.map((locale) => {
        if (locale.value === this.state.active) {
          return ( <MenuItem key={locale.value} onClick={() => this.onSelectLocale(locale.value)}>{locale.name}</MenuItem>
          )} else  {
          return ( <MenuItem key={locale.value} onClick={() => this.onSelectLocale(locale.value)}>{locale.name}</MenuItem>
      )
      }
    }
   )}
    
  </Select>
</FormControl>
  
    );
  }
 
  onSelectLocale(id) {
    let dochangelang = id;
    this.loadLocales(dochangelang);
    this.setState ({
      active: dochangelang
    })
    //window.location.search = `?lang=${lang}`;
  };

}


const mapStateToProps = state => ({
  state: state,
  islogin: state.gettocken.islogin,
  error: state.gettocken.error

});


export default connect(mapStateToProps)(Layout);



 
